import { ResidentialService } from './../../questionarie-signup/questionnaire-residential/residential.service';
import { Component, OnInit, AfterViewInit, Input, } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

declare var $;

@Component({
  selector: 'app-pre-contact',
  templateUrl: './pre-contact.component.html',
  styleUrls: ['./pre-contact.component.css']
})
export class PreContactComponent implements OnInit, AfterViewInit {
  modalVisible = false;
  header;
  @Input() contVisible: boolean;
  constructor(private residentialService: ResidentialService, private route: ActivatedRoute,private title: Title,private meta: Meta) {
    $(window).on('popstate', this.handleBackPressHelp);
    document.addEventListener('backbutton', this.handleBackPressHelp, false);

    this.route.queryParams.subscribe(params => {
      const paramValue = params['textChange'];
      if (paramValue) {
        this.header = 'Sorry! Your ESI ID number is nowhere to be found';
      } else {
        this.header = 'Let us answer all your energy related needs!';
      }
    });
   }

  ngOnInit() {
    
    this.title.setTitle('Have a Question? Contact Us! | Honest Gorilla');
    this.meta.updateTag({name: 'keywords', content: 'contact us,customer care,customer service,someone help me,help,customer needs assistance,billing,energy choice,honest gorilla,answer all your energy needs'});
    this.meta.updateTag({name: 'description', content: 'Want to leave us feedback? Got a burning question? Get in touch with us, we’d love to hear from you.'});
    this.meta.updateTag({name: 'author', content: 'HonestGorilla'});
    this.meta.updateTag({name: 'robots', content: 'index, follow'});
  }
  ngAfterViewInit(): void {
    $('.navbar-toggler').click(function () {
      $('.navbar').toggleClass('parent');
    });
  }
  onClose(isVisible: boolean) {
    this.modalVisible = isVisible;
  }
  showModal() {
    this.residentialService.loadScriptFiles('../../../../assets/js/custom.js');
    this.modalVisible = true;
  }
  handleBackPressHelp(event) {
    event.preventDefault();
    event.stopPropagation();
    $('.modal').modal('hide');
    $('.modal-backdrop').remove();
      // Disable the Browser back button.
      history.pushState(null, null, location.href);
      window.onpopstate = function () {
        history.go(1);
      };
  }
}
